export default __webpack_public_path__ + "static/media/people.icon.99a5eba8.svg";